import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function AnalysisReportPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={19} docNamePdf={"AnalysisReport.pdf"} docName={"AnalysisReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
